import React from 'react';
import classNames from 'classnames';

export interface SlidingButton {
	title: string;
	subtitle?: string;
	icon?: React.ReactNode;
	onClick?: () => void;
}

interface SlidingButtonGroupProps {
	activeButton: number;
	slidingButtons: SlidingButton[];
	inset?: number;
}

export default function SlidingButtonGroup({
	activeButton,
	slidingButtons,
	inset = 0,
}: SlidingButtonGroupProps) {
	const slotPercent = 100 / slidingButtons.length;

	const backgroundStyle = inset > 0 ? {
		width: `calc(${slotPercent}% - ${inset * 2}px)`,
		transform: `translateX(calc(${activeButton * 100}% + ${activeButton * inset * 2}px))`,
		top: inset,
		left: inset,
		height: `calc(100% - ${inset * 2}px)`,
	} : {
		width: `${slotPercent}%`,
		transform: `translateX(${activeButton * 100}%)`,
	};

	return (
		<div className="sliding-button-group" data-testid="sliding-button-group">
			<div
				className={`sliding-button-background active-button-${activeButton}`}
				style={backgroundStyle}
			/>
			{slidingButtons.map(({
				title,
				subtitle,
				icon,
				onClick,
			}, index) => (
				<button
					key={index}
					onClick={onClick}
					className={classNames(
						'sliding-button',
						{ 'sliding-button--active': index === activeButton },
					)}
				>
					{icon && (
						<div className="sliding-button-icon">
							{icon}
						</div>
					)}
					<div className="sliding-button-text">
						<h5 className="bl-font-header">{title}</h5>
						{subtitle && <p className="bl-font-s2">{subtitle}</p>}
					</div>
				</button>
			))}
		</div>
	);
}
